const styles = {
    formContainer: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: 'white', 
        padding: 20,
        boxShadow: '10px 3px 10px grey',
        textAlign: 'center'
    },
    innerFormContainer: {
        // display: 'flex',
        // width: '100%',
        // alignItems: 'center',
        // justifyContent: 'space-evenly'
    },
    formInput: {
        marginRight: 8
    }
}

export default styles;